import { MyDocumentsData, getMyDocumentsEndpoint } from 'cpfr-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<MyDocumentsData[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'myDocuemnts',
    fetchCallback() {
        return CpDataApi.get(getMyDocumentsEndpoint()).then((response) => response.data);
    },
});

export default reducer;
export const fetchMyDocuments = fetchData;
